import { Middleware } from 'redux';
import { IS_LOCAL } from '../constants/constants';

export const loggerMiddleware: Middleware = (_) => (next) => (action) => {
    if (IS_LOCAL) {
        console.log('Dispatching:', action);
        next(action);
    }
};
